import { render, staticRenderFns } from "./MenuUserNotifications.vue?vue&type=template&id=2e6e63fc&scoped=true"
import script from "./MenuUserNotifications.vue?vue&type=script&lang=js"
export * from "./MenuUserNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuUserNotifications.vue?vue&type=style&index=0&id=2e6e63fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e63fc",
  null
  
)

export default component.exports